import React from 'react';

const VideoBg = ({ src, poster, opacity = 0.4, parallaxOffset = 0 }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100vh',
      zIndex: 0,
      overflow: 'hidden',
      pointerEvents: 'none'
    }}>
      <video
        autoPlay
        loop
        muted
        playsInline
        poster={poster}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          minWidth: '100%',
          minHeight: '100%',
          width: 'auto',
          height: 'auto',
          transform: `translate(-50%, -50%) translateY(${parallaxOffset * -0.2}px)`,
          objectFit: 'cover',
          opacity: opacity,
          transition: 'transform 0.1s ease-out'
        }}
      >
        <source src={src} type="video/webp" />
        <source src={src.replace('.webp', '.mp4')} type="video/mp4" />
      </video>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(to bottom, rgba(5, 7, 10, 0.4) 0%, rgba(5, 7, 10, 1) 100%)',
        zIndex: 1
      }} />
    </div>
  );
};

export default VideoBg;
